import {formatCellPhoneNumber} from "../functions";

function formatConnectionInstance(connectionInstance) {

 return {
    qrCode: connectionInstance.sessionQrcodeImage,
    sessionId: connectionInstance.sessionId,
    instanceId:connectionInstance.instanceId,
    statusName: connectionInstance.sessionStatus.name,
    statusCode: connectionInstance.sessionStatus.code,
    profilePic: connectionInstance.instanceProfilePic,
    phoneNumber: formatCellPhoneNumber(connectionInstance.instancePhoneNumber),
    profileName: connectionInstance.instanceProfileName,

 }
}

function formatConfig(config) {
 return {
   active: config.hasInstanced,
   hour: config.reminder.appointment.hour,
 }
}





export const formatResponses = {
  formatConnectionInstance: (connectionInstance) => formatConnectionInstance(connectionInstance),
  formatConfig: (confg) => formatConfig(confg),
};
